import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
// import {Toast, toast} from '../component/master/toast'
// import React from 'react'
// const {Toast, toast} = React.lazy(() => import('../component/master/toast'))
import action from '../action'
import { getLoginRow, Ref, Route, copy, cookies, cache, session } from '../global'
import { go, localhost, act, dispatch, tcp, tcp2 } from '.'
const ID = 'middle'
const __DEV__ = import.meta.env.__DEV__
try {
  console.log('Middle try __DEV__', __DEV__)
  // if (import.meta.env.DEV) { ... }
} catch (e) {
  console.log('Middle catch __DEV__ not defined')
} finally {
  console.log('Middle finally process.env.NODE_ENV', process.env.NODE_ENV)
}

export const middle = store => {
  // setStore(store)
  return next => r => {

//   }
// }
//
// export const middle = store => next => r => { // used by store/createStore()
//   setStore(store)
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Read-only
// if (!r) debugger
if (r.default) debugger
// if (r.param) debugger
if (r.print) debugger
if (r.offset) debugger
    const lang=r.param?.lang || _.EN, route=r.route, def=r.default
    const prop=store.getState().master, park=prop.park, cookie=cookies(), print=r.print||_.PUB, offset=r.offset||0
    const master = { ...prop.init.master?.response }
    let key, vid, vendorId, mid, res, url, title, view, state, meta, rows, row, pks, printer
    switch (r.type) {
      case 'u':
      const vendorname = route[0]
      const pk = route.length > 2 && !isNaN(route[2]) ? route[2] : null
      const vendor = vendorname=='q' ? copy(prop.buy) : (cache(`${cache(vendorname)}`) || [])
      const localVendor = _.TITLE_.includes(vendorname)
      if (!vendor.id && !localVendor) {
        tcp2({
          request: {type: 'table', find: [vendorname]},
          credential: true,
          url: `https://${cookie.p}.${_.DOMAIN}/fec/table${__DEV__ ? '.dev' : ''}.php?api=username`,
          parking: false,
          callback: response => {
            // const id = typeof response == 'object' && Object.keys(response)[0]
            const id = typeof response == 'object' && Object.keys(response).length && Object.keys(response)[0]
            if (id) dispatch({buffer: {[cookie.p]: {login: {user: {default: {[id]: response[id]}}}}}})
            setTimeout(() => {
              if (id) callback(getLoginRow(response[id]))
              else {
                alert(`${master.error.i}, ${master.find.i} ${vendorname}`)
                action.find(vendorname) // experimenting
                window.location.href = `/master/welcome?lang=${lang}`
                // window.location.href = `/master/welcome`
              }
            }, 1111)
          }
        })
      }
      const callback = vendor => {
        if (!vendor.id && !localVendor) return
        const db = vendor.id || 'find'
        const u = route[1] || 'store'
        const views = u=='store' ? _.STORE_ : (_.USER_.includes(u) ? ['login'] : [u])
        const verb = _.LOGIN_[u] || _.LOGOUT_[u] || 'default'
        const v = u=='store' ? 'config' : (_.USER_.includes(u) ? 'login' : u)
    if (!v)debugger
    if (v=='chat')debugger
        const owner = cookie.login && vendorname==cookie.username
    // if (v=='pay')debugger
        const request = {route, u, lang}
        if (!localVendor) request.vendor = vendor.id ? Object.values(vendor) : 'find'
        // const net = {}
        const net = {login: {default: 'find'}}
        if (u=='store') _.COUNT_.forEach(_v => net[_v] = {[db]: {count: _.PUB}})
        // else if (_.Q_.includes(v)) {
        //   if (!net[v])              net[v] = {}
        //   if (!net[v][db])          net[v][db] = {}
        //   if (!net[v][db].count) net[v][db].count = _.PUB
        // }
        if (v!='otp') {
          if (!_.MASTER_.includes(v)) {
            if (!net.q) net.q = {}
            if (!net.q.default) net.q.default = 'find'
          }
          if (!_.LOCAL_.includes(v)) {
            if (!net[v]) net[v] = {}
            if (!net[v][verb]) net[v][verb] = 'find'
          }
          if (!net.purchase) net.purchase = {}
          if (!net.purchase.default) net.purchase.default = 'find'
          if (owner) {
            if (!net.q[db]) net.q[db] = {}
            if (!net.q[db].where) net.q[db].where = 'valid'

            if (!net.notice) net.notice = {}
            if (!net.notice[db]) net.notice[db] = {}
            if (!net.notice.default) net.notice.default = 'find'
            if (!net.notice[db].count) net.notice[db].count = _.PUB
          }
        }
        // if (v!='otp' && !_.MASTER_.includes(v)) {
        //   if (!net.q) net.q = {}
        //   if (!net.q.default) net.q.default = 'find'
        //   // if (!net.purchase)        net.purchase = {}
        //   // if (!net.purchase.default) net.purchase.default = 'find'
        //
        //   // notice printer should be brought in from Go Shop click when login is true
        //   // which will also fix loop of ERROR, SUGGEST, RECOMMEND ... currently they are directly found in cache without loop
        //   // if (!net.notice)         net.notice = {}
        //   // if (!net.notice.default)  net.notice.default = 'find'
        // }
        // if (v!='otp' && !_.LOCAL_.includes(v)) {
        //   if (!net[v]) net[v] = {}
        //   if (!net[v][verb]) net[v][verb] = 'find'
        // }
        if (_.Q_.includes(v)) {
          if (!net[v]) net[v] = {}
          if (!net[v][db]) net[v][db] = {}
          if (!net[v][db].count) net[v][db].count = _.PUB
          if (!net[v][db].default) net[v][db].default = pk ? {[pk]: 'find'} : []
    // if (IO.select) debugger
          if (window.opener) {
          // if (IO.select) {
            console.log('window.opener needs middle enhancement .....')
            // net[v][db].default = IO.select.iState.value.reduce((acc, pk, i) => {
            //   if (!(i<_.LIMIT)) return acc
            //   acc[pk]='find'
            //   return acc
            // }, {})
          }
        }
        if (u=='store' || _.Q_.includes(v)) {
          if (!net.config) net.config = {}
          if (!net.config.default) net.config.default = 'find'
          if (!net.config[db]) net.config[db] = {}
          if (!net.config[db].count) net.config[db].count = _.PUB
          if (!net.config[db].default) net.config[db].default = []
        }
        if (_.FILE_.includes(v)) {
          if (!net.media) net.media = {}
          if (!net.media.default) net.media.default = 'find'
        }
        // if (u!='otp' && !net.purchase) net.purchase = {}
        // if (u!='otp' && !net.purchase.default) net.purchase.default = 'find'
        // if (u!='otp') {
        //   if (!net.purchase) net.purchase = {}
        //   if (!net.purchase.default) net.purchase.default = 'find'
        //   if (owner) {
        //     if (!net.q[db]) net.q[db] = {}
        //     if (!net.q[db].where) net.q[db].where = 'valid'
        //
        //     if (!net.notice) net.notice = {}
        //     if (!net.notice[db]) net.notice[db] = {}
        //     if (!net.notice.default) net.notice.default = 'find'
        //     if (!net.notice[db].count) net.notice[db].count = _.PUB
        //   }
        // }
        // if (!net[_.LOGIN]) net[_.LOGIN] = {}
        // if (!net[_.LOGIN][_.UPD]) net[_.LOGIN][_.UPD] = 'find'
        // if (login && !owner && vendorname!=_.MASTER) {
        //   if (!net[_.FOLLOW])              net[_.FOLLOW] = {}
        //   if (!net[_.FOLLOW].default)       net[_.FOLLOW].default = 'find'
        //   if (!net[_.FOLLOW][db])          net[_.FOLLOW][db] = {}
        //   if (!net[_.FOLLOW][db][_.WHERE]) net[_.FOLLOW][db][_.WHERE] = `\`${_.FROM}\`=${userId}`
        // }
        // if (u!='otp' && owner) {
        //   // if (!net.purchase[db])          net.purchase[db] = {}
        //   // if (!net.purchase[db].count) net.purchase[db].count = _.PUB
        //   // if (!net.q)                   net.q = {}
        //   // if (!net.q.default)            net.q.default = 'find'
        //   if (!net.q[db]) net.q[db] = {}
        //   if (!net.q[db].where) net.q[db].where = 'valid'
        //
        //   if (!net.notice) net.notice = {}
        //   if (!net.notice[db]) net.notice[db] = {}
        //   if (!net.notice.default) net.notice.default = 'find'
        //   if (!net.notice[db].count) net.notice[db].count = _.PUB
        // }
  if (u=='media' && !net.media[db]) debugger
        // if (u=='media' && net.media[db].count) debugger
        // const fromNeed = `\`${_.FROM}\`=${uid}`
        if (u=='media') {
          // const need = `\`${_.ALBUM}\`='${_.FEED}'`
          // delete(net.media[db].count)
          // net.media[db][_.WHERE] = need
          // net.media[db].count = need
          delete(net.config)
          delete(net.media[db])
          net.media[db]={album: _.FILE_[0]}
        }
        request.buffer = {[vendor.home || cookie.p]: net}
        // request.buffer['q10'] = {login: {default: 'find'}}
        // request[_.PREVIEW] = 1
        // request.buffer = {[vendor.home || 'vendor.home']: net}
    // if (vendorname=='Q')debugger
        // if (u==_.STAGE) delete(net[u])
        // if (Object.keys(net).length) tcp(request, shard, 1)
        console.log(`Middle`, {request})
        if (Object.keys(net).length) tcp2({request, credential: true})
      }
      callback(vendor)
      break

      // case 'park': debugger
      // case 'p': debugger
      // break
      case 'init':
      if (r.init?.master?.response) break // do nothing
      const cacheInit = cache(`init${r.lang}`)
      // const sessionInit = cache('init')
      // console.log(`Middle.INIT cache`, cacheInit)
      // console.log({ID, cacheInit, sessionInit})
      // const _r = {debug: ID, ...r}
      // const _r = {...r, home: 'q10'}
      const _r = {...r}
      if (cacheInit) {
        _r.response = cacheInit.response;
        // if (sessionInit)
        localhost(_r)
        // r[_.TIME] = cacheInit.response[_.TIME]
      }// else cache('init', null)
      // tcp(_r, cookie.p)
      // tcp(_r, 'q10')
      tcp2({request: _r})
      //   debugger
      // }})
      return next(r)
      break

      case 'find':debugger;break
      case 'partresponse': debugger
      if (!route) break
      if (!route) debugger
      url = `/${route.join('/')}`
      console.log(`Middle.Part.Response title=${document.title}, url=${url}, pathname=${window.location.pathname}`, prop)
      if (window.location.pathname != url) {debugger
        // const _uris = []
        const _route = Route()
        console.log(_route)
        // window.location.pathname.split('/').forEach(t => t.length && _uris.push(t))
        if (_route.length < 2) { debugger// / and /en
          console.log('Middle.Part.Response REPLACE', url)
          go(Ref.history.replace, route)
        } else {debugger
          console.log('Middle.Part.Response PUSH', url)
          go(Ref.history.push, route)
        }
      }
    }
    return next(r)
  }
}

export default middle
